<div @snackbarAnimation class="smash-snackbar-container">
    <div class="smash-snackbar-content">
        <ng-content></ng-content>
    </div>
</div>